module.exports = __webpack_public_path__ + "media/images/mermaid_cream-770d305dde9f419e03b9ceb087ff52f8.png";